import { Component, OnInit } from '../../../ng';
import { ControllerWithCommandServiceBase } from '../controller-with-command-service-base';
import { PageContainerService } from '../../../services';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(public pcs: PageContainerService) {
  }

  ngOnInit() {
  }

  get loggedIn(): boolean {
    var result = this.pcs.clientSessionService.loggedIn;
    return result;
  }

  navigateHome() {
    this.pcs.router.navigate(['dashboard']);
  }

  logout() {
    this.pcs.apiService.Logout({}, true).then((response) => this.onLogoutSucceeded());
  }

  onLogoutSucceeded() {
    this.pcs.clientSessionService.reset();
    this.pcs.router.navigate(['login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/framework/header/header.component.ts